import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { OffcanvasType } from '@shared/@types';

export class DrawerDirection {
  static readonly LEFT = 'left';
  static readonly RIGHT = 'right';
  static readonly TOP = 'top';
  static readonly BOTTOM = 'bottom';
}

@Component({
  selector: 'app-icam-drawer',
  templateUrl: './icam-drawer.component.html',
  styleUrl: './icam-drawer.component.scss'
})
export class IcamDrawerComponent {
  @Input() title = 'Drawer Title';
  @Input() direction: DrawerDirection = 'right';
  @ViewChild('drawerContent') drawerContent!: TemplateRef<any>;

  private drawerRef?: NgbOffcanvasRef;

  constructor(private offcanvasService: NgbOffcanvas) {}

  getDirection(direction: DrawerDirection): OffcanvasType {
    switch (direction) {
      case DrawerDirection.LEFT:
        return 'start';
      case DrawerDirection.RIGHT:
        return 'end';
      case DrawerDirection.TOP:
        return 'top';
      case DrawerDirection.BOTTOM:
        return 'bottom';
      default:
        return 'end';
    }
  }

  open() {
    if (!this.drawerRef) {
      this.drawerRef = this.offcanvasService.open(this.drawerContent, {
        position: this.getDirection(this.direction)
      });

      this.drawerRef.dismissed.subscribe(() => {
        this.drawerRef = undefined;
      });
    }
  }

  close() {
    if (this.drawerRef) {
      this.drawerRef.dismiss();
    }
  }
}
